module.exports = __webpack_public_path__ + "img/poster-facing-the-mirror.f0e5c461.jpg";